import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
} from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBhJXcD3JdVirRMrSXg6R4rB3sS8VV-m-4",
  authDomain: "badbank-mern-18fd4.firebaseapp.com",
  projectId: "badbank-mern-18fd4",
  storageBucket: "badbank-mern-18fd4.appspot.com",
  messagingSenderId: "286803226875",
  appId: "1:286803226875:web:716389e54e6f89f243805e",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
console.log("Firebase app initialized:", app);

const auth = getAuth(app);

export {
  app,
  auth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
};
